module.exports = __webpack_public_path__ + "img/selfieidentytycard.f0490baf.png";